'use client'
import ShoppingBag from '@/components/icons/shopping-bag'
import { Button } from '@/components/ui/button'
import {
  useCartCount,
  useToggleShowCart,
  withCartStoreSuspense,
} from '@/stores/cart-store'

const ShoppingCartButton = () => {
  const toggleShowCart = useToggleShowCart()
  const count = useCartCount()

  return (
    <Button
      variant={'plain'}
      size={'plain'}
      className="relative"
      onClick={toggleShowCart}
    >
      <ShoppingBag className="size-6 text-black" />
      {count > 0 && (
        <span className="absolute -bottom-0.5 -right-1 flex size-4 items-center justify-center rounded-full bg-secondary-900 text-2xs text-secondary-50">
          {count}
        </span>
      )}
    </Button>
  )
}

export default withCartStoreSuspense(ShoppingCartButton)
